module.exports = __webpack_public_path__ + "img/tombelaine_1_cover_nl.77a23bb8.jpg";